import { render, staticRenderFns } from "./TypeAnswer.vue?vue&type=template&id=d4e51470"
import script from "./TypeAnswer.vue?vue&type=script&lang=js"
export * from "./TypeAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e51470')) {
      api.createRecord('d4e51470', component.options)
    } else {
      api.reload('d4e51470', component.options)
    }
    module.hot.accept("./TypeAnswer.vue?vue&type=template&id=d4e51470", function () {
      api.rerender('d4e51470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TypeAnswer.vue"
export default component.exports